import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ApiService } from 'app/core/api/api.service';
import { BehaviorSubject, Observable, tap, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class VenueService {
    private _data: BehaviorSubject<any> = new BehaviorSubject(null);
    private _apiService = inject(ApiService);
    private _updated = new Subject<Object>();
    updated$ = this._updated.asObservable();
    private dataStore: { venues: any[] } = { venues: [] };
    /**
     * Constructor
     */
    constructor(private _httpClient: HttpClient) {}

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Getter for data
     */
    get data$(): Observable<any> {
        return this._data.asObservable();
    }

    get(): any {
        return this.dataStore.venues;
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------


    /**
     * Get all venues for sidebar
     */
    getVenues(): Observable<any> {
        return this._apiService.get('venue').pipe(
            tap((venues: any) => {
                this._data.next(venues); 
                this._updated.next(venues);
                this.dataStore.venues = venues;
            })
        );
    }

    getVenuesPage(page: number, limit: number, sortBy?: string): Observable<any> {
        const query = new URLSearchParams({
            paginated: 'true',
            page: String(page),
            limit: String(limit),
        });
        if (sortBy) {
            query.set('sortBy', sortBy);
        }
        return this._apiService.get(`venue?${query.toString()}`);
    }

    getVenueById(id: string): Observable<any> {
        return this._apiService.get('venue/'+id).pipe(
            tap((venues: any) => {
                this._data.next(venues);
            })
        );
    }

    /**
     * Get venue with cancellation policy and privacy policy
     */
    getVenueWithPolicies(id: string): Observable<any> {
        return this._apiService.get(`venue/${id}`);
    }

    /**
     * Get all locations for dropdown
     */
    getLocations(): Observable<any> {
        return this._apiService.get('locations');
    }

    /**
     * Create a new venue
     */
    createOrUpdateVenue(venueData: any): Observable<any> {
        if (venueData.id !== undefined) {
            const { id, ...updatePayload } = venueData;
            return this._apiService.put(`venue/${id}`, updatePayload);
        } else { 
            return this._apiService.post('venue', venueData);
        }
        
    }

     /**
     * Create a new court
     */
    delete(venueId: string): Observable<any> {
        return this._apiService.delete(`venue/${venueId}`);
    }


getCourtsByVenue(venueId: string): Observable<any> {
  return this._apiService.get(`venue/${venueId}/courts`);
}}

